import { connect } from 'react-redux';
import type { DefaultRootState } from 'react-redux';
import type { Dispatch } from 'redux';

import automationRulesReducer from '@app/reducers/entities/automation-rules';

import AutomationRuleComponent from './automation-rule';
import type { Props } from './automation-rule';

type StateProps = {
  automationRule: Oneflow.AutomationRule;
  fetchState: ReturnType<typeof automationRulesReducer.getFetchSelector>;
};

type FetchAutomationRule = (props: { onSuccess: () => void; onFailure: () => void }) => void;

type DispatchProps = {
  fetchAutomationRule: FetchAutomationRule;
};

export type OwnProps = Omit<Props, keyof StateProps | keyof DispatchProps>;

export const mapStateToProps = (state: DefaultRootState, ownProps: OwnProps) => {
  const automationRule = automationRulesReducer.getAutomationRuleSelector(state, {
    id: ownProps.match.params.automationRuleId,
  });
  const updateState = automationRulesReducer.getUpdateSelector(state, {
    id: ownProps.match.params.automationRuleId,
  });
  const removeState = automationRulesReducer.getRemoveSelector(state, {
    id: ownProps.match.params.automationRuleId,
  });

  return {
    automationRule,
    fetchState: automationRulesReducer.getFetchSelector(state, {
      id: ownProps.match.params.automationRuleId,
    }),
    updateState,
    removeState,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  fetchAutomationRule: () => {
    dispatch(
      automationRulesReducer.fetchAutomationRule({
        id: ownProps.match.params.automationRuleId,
        params: {
          workspaceId: ownProps.match.params.id,
        },
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AutomationRuleComponent);
